import { _ } from '../../shared/utils';
import { Station } from '../../custom/vrgroup/common/station';

export class FilterChangeEvent {
  constructor(public startDate: Date,
              public endDate: Date,
              public selectedFilters: ElementFilters,
              public filterDefinitions: FilterDefinitionEntry[],
              public vivoBody?: VivoBody,
              public station?: Station[]) {
  }
}

export interface ElementFilters {
  date: DateFilter;
  text: string;
  type: EventType;
}

export interface FilterDefinitionEntry {
  name: string;
  type: 'single' | 'multi';
  filterValues?: FilterValue[];
  vivoValues?: any;
}

export class VivoBody {
  page: string;
  limit: number;
  filters?: Filters[];
  viewOptions?: ViewOptions[];

  constructor() {
    this.page = '1';
    this.limit = 50;
    this.filters = [];
    this.viewOptions = [];
  }
}


export interface Filters {
  property?: Property;
  option?: {value: string};
  query?: {key: string, value: string}[];
  value?: string | {_id: string}[];
}

export interface Property extends Filters {
  _id: string;
  type: string;
}

export interface ViewOptions {
  orderBy: string;
  reverse: boolean;
}

export interface FilterValue {
  name: string;
  description: string;
  active: boolean;
}

export type DateFilter = 'All' | 'Day' | 'Week' | 'Month' | 'Year';
export type EventType = 'All' | 'Alarms' | 'VIVO';

export const dateFilterValues: DateFilter[] = ['All', 'Day', 'Week', 'Month', 'Year'];
export const eventTypes: EventType[] = ['All', 'Alarms', 'VIVO'];
